<template>
    <Head title="Register" />
    <!-- mobile view start -->
     <div v-if="this.checkMobile()">
         <!-- Mobile Screen -->
       <br>
         <Link @click="back" class="bg-white border-0 hover:bg-white hover:no-underline pl-4 pr-5 pt-2 pb-2" ><i class="fas fa-chevron-left text-black text-xl"></i></Link>
 
         <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pl-5 pr-5">
         <div class="mt-1 text-center">
             <img v-bind:src="'../imgs/aruvaa_logo.png'" class="block" style="margin:auto; display:block; width:150px; height:40px">
         </div> 
         
             <div class="text-center mt-2">
             <h3 class="text-center">Register</h3>
         </div>
         <br>
             <div>
           
           <div class="text-center">
             <jet-validation-errors class="mb-4" />
           </div>
             <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                 {{ status }}
             </div>
 
             
             <form @submit.prevent="submit">
 
                 <div class="form w-full">
                         <jet-input id="name" type="text" class="block w-full border float-input" v-model="form.name" placeholder="  " required />
                         <label  for="name" value="Name" class="label-name rounded" >
                             <span class="content-name bg-white rounded text-sm pl-1 pr-1 ml-1 mr-1">Name</span>
                         </label>
                 </div>
 
                 
                 <div class="form w-full mt-4">
                         <jet-input id="email" type="email" class="block w-full border float-input" v-model="form.email" placeholder="  " required />
                         <label  for="email" value="Email" class="label-name rounded" >
                             <span class="content-name bg-white rounded text-sm pl-1 pr-1 ml-1 mr-1">Email</span>
                         </label>
                 </div>

                 <div class="form w-full mt-4">
                         <jet-input id="phone" type="number" class="block w-full border float-input" v-model="form.phone" placeholder="  " required />
                         <label  for="phone" value="Phone Number" class="label-name rounded" >
                             <span class="content-name bg-white rounded text-sm pl-1 pr-1 ml-1 mr-1">Phone Number</span>
                         </label>
                 </div>

 
                        
                 <div class="form w-full mt-4">
                         <jet-input id="password" type="password" class="block w-full border float-input" v-model="form.password" placeholder="  " required />
                         <label  for="password" value="Password" class="label-name rounded" >
                             <span class="content-name bg-white rounded text-sm pl-1 pr-1 ml-1 mr-1">Password</span>
                         </label>
                 </div>
 
             
                 <div class="form w-full mt-4">
                         <jet-input id="password_confirmation" type="password" class="block w-full border float-input" v-model="form.password_confirmation" placeholder="  " required />
                         <label  for="password_confirmation" value="Confirm Password" class="label-name rounded" >
                             <span class="content-name bg-white rounded text-sm pl-1 pr-1 ml-1 mr-1">Confirm Password</span>
                         </label>
                 </div>
 
 
             <!--    
                 <div>
                     <jet-label for="name" value="Name" />
                     <jet-input id="name" type="text" class=" block w-full" v-model="form.name" required autofocus autocomplete="name" />
                 </div>
 
                 <div class="mt-3">
                     <jet-label for="email" value="Email" />
                     <jet-input id="email" type="email" class=" block w-full" v-model="form.email" required />
                 </div>
 
                 <div class="mt-3">
                     <jet-label for="password" value="Password" />
                     <jet-input id="password" type="password" class=" block w-full" v-model="form.password" required autocomplete="new-password" />
                 </div>
 
                 <div class="mt-3">
                     <jet-label for="password_confirmation" value="Confirm Password" />
                     <jet-input id="password_confirmation" type="password" class=" block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                 </div>
             -->
                 <div class="mt-2" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
                     <jet-label for="terms">
                         <div class="flex items-center">
                             <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />
 
                             <div class="ml-2">
                                 I agree to the <a target="_blank" :href="route('terms.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and <a target="_blank" :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a>
                             </div>
                         </div>
                     </jet-label>
                 </div>
 
                 <div class="mt-4">
                     <jet-button class="w-full text-center justify-content-center text-white bg-black rounded p-2" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                         Register
                     </jet-button>
                 </div>
             </form>
 <br><br><br>
             <div class="text-center">
                 <span>
                 Already have account?
                 <Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                         Login here
                 </Link> 
                 </span>
             </div>
 
 
             <div class="privacy-style text-center inset-x-0 text-lg ml-4 mt-4">
                 <span class=""> 
                 <a href="{{ url('/register') }}" class="no-decoration text-dark">
                     <span class="ml-2 text-sm">Terms</span>
                 </a> 
                 </span> |<span> 
                 <a href="{{ url('/register') }}" class=" text-dark no-decoration">
                     <span class="ml-2 text-sm">Privacy Policy</span>
                 </a> 
                 </span>
             </div>
         
         </div>
         </div>
     </div>
     <!-- mobile view end -->
 
     <div v-else>
     
       <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
       <div class="left ">
       <div class=" ml-3 mt-2 mb-5">
        <a :href="baseUrl" class=" ">
        <img :src="'/imgs/aruvaa_logo.png'" alt="" style="width:150px; height:40px" >
        </a>
       </div>
       <div class=" font-bold py-4 px-5">
       <h2 class="text-gray-600">Start your</h2>
       <h2 class="mt-2 text  font-bold" style="color: #4BB2B0;">30-days free trial</h2>
       </div>
       <img :src="'/imgs/register.png'" alt="" width="" class="ml-5 pb-2">
     </div>
     <!-- ... -->
     <div class="grid-cols-1 lg:col-span-2 lg:px-3 lg:px-1 px-3  md:grid-cols-1 h-auto mt-2  pb-4" style="border:none">
     
     
         
       <div class=" sign-head mt-5">
         <h3 class= "font-extrabold tracking-wide mt-5 font-sans text-black " style="color: #4BB2B0;">Sign Up</h3>
        
         <Link :href="route('login')" class="font-semibold underline text-sm text-gray-600 hover:text-gray-900">
           Alredy a member?<span class="" style="color: #4BB2B0;"> Sign In</span>
         </Link>
         </div>
         <!-- start signup form code -->
         <div class="signup-form mt-4">
         
     <form @submit.prevent="submit">
       <div class="mb-3">
         <jet-label for="name" value="Name*" class="block text-gray-700 text-sm">
          </jet-label>
           <jet-input id="name" type="text" class="border rounded  border-gray-300 px-3 py-2 mt-1 block w-full" v-model="form.name" required autofocus autocomplete="name" />   
       </div>

       <!-- <div class="mb-3">
      <jet-label :value="`Name${form.nameRules.required ? '*' : ''}`" class="block text-gray-700 text-sm" />
      <jet-input id="name" type="text" class="border rounded  border-gray-300 px-3 py-2 mt-1 block w-full" v-model="form.name" :required="form.nameRules.required" autofocus autocomplete="name" />
      </div>   -->


       <div class="mb-3">
         <jet-label for="email" value="Email*" class="block text-gray-700 text-sm"/>
           <jet-input id="email" type="email" class="border rounded  border-gray-300 px-3 py-2 mt-1 block w-full" v-model="form.email" required />
         
       </div>
       <div class="mb-3">
         <jet-label for="phone" value="Phone Number*" class="block text-gray-700 text-sm"/>
         <jet-input type="number" id="phone" class="border rounded border-gray-300 px-3 py-2 mt-1 w-full"  v-model="form.phone" required />
       </div>
       <div class="mb-3">
         <jet-label for="password" value="Password*" class="block text-gray-700 text-sm"/>
           <jet-input id="password" type="password" class="border rounded  border-gray-300 px-3 py-2 mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
         
       </div>
       <div class="mb-3">
         <jet-label for="password_confirmation" value="Confirm Password*" class="block text-gray-700 text-sm"/>
           <jet-input id="password_confirmation" type="password" class="border rounded border-gray-300 px-3 py-2 mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
       
       </div>
 
       <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
                     <jet-label for="terms">
                         <div class="flex items-center">
                             <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />
 
                             <div class="ml-2">
                                 I agree to the <a target="_blank" :href="route('terms.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and <a target="_blank" :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a>
                             </div>
                         </div>
                     </jet-label>
                 </div>
       <div class="">
         <button type="submit" class="px-4 py-2 text-white font-semibold rounded" style="background-color: #4BB2B0;" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">Create Account</button>
       </div>
     </form>
       </div>
         <!-- end signup form code -->
       
     </div>
    
       
       </div>
     </div>
   </template>
   
   <script>
     import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
     import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
     import JetButton from '@/Jetstream/Button.vue'
     import JetInput from '@/Jetstream/Input.vue'
     import JetCheckbox from '@/Jetstream/Checkbox.vue'
     import JetLabel from '@/Jetstream/Label.vue'
     import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
     import { Head, Link } from '@inertiajs/inertia-vue3';
 
     export default {
         components: {
             Head,
             JetAuthenticationCard,
             JetAuthenticationCardLogo,
             JetButton,
             JetInput,
             JetCheckbox,
             JetLabel,
             JetValidationErrors,
             Link,
         },
 
         data() {
             return {
              baseUrl: this.$utils.goToUrl(window.env.baseTenantUrl),
                 form: this.$inertia.form({
                     name: '',
                     email: '',
                     phone:'',
                     password: '',
                     password_confirmation: '',
                     terms: false,
                 })
             }
         },
         mounted() {
           this.checkMobile();
         }
             ,
         methods: {
             submit() {
                 this.form.post(this.route('register'), {
                     onFinish: () => this.form.reset('password', 'password_confirmation'),
                 })
             }
             ,checkMobile() {
                 if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                     console.log("CheckMobile Called: Mobile");
                     return true;
                 } else {
                   console.log("CheckMobile Called: Desktop");
                     return false;
                 }
             }
             ,back() {
                 window.history.back();
             // this.$inertia.get('/'+this.moduleRoute);
             }
         }
          
     }
 </script>
   
   <style>
   a{
     text-decoration: none !important;
   }
   .select:hover{
     background: #B8E3CF !important;
   }
   .left-text{
     margin-top: 100px;
   }
   /* .full{
      background-color: #ffffff;
      height:100vh;
      background-size: cover;
      overflow: hidden;
   } */
   
   .card{
     /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
     background-color: #F6F6F6;
     margin: 90px 70px;
   }
   
   .rect{
     /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
     margin: 0px 100px;
     cursor: pointer;
   }
   /* .rect:hover{
     color: #F6F6F6;
   } */
   p{
   margin-bottom: 0.1rem;
   }
   h6,h3,h2{
      margin-bottom: 0.03rem;
   }
   /* .rect :hover{
     border: rgb(21, 245, 185);
   } */
   .left{
     background-color:#EFF3F2 ;
     /* height: 100vh; */
   }
   
 
   .signup-form {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   margin: 0 auto;
   max-width: 400px;
   
 }
 
 .signup-form form {
   width: 100%;
 }
 label {
   margin-bottom: -.2rem;
 }
 .form-input {
   padding: 0.5rem;
   border: 1px solid #ccc;
   box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
   transition: box-shadow 0.3s ease;
 }
 
 .form-input:focus {
   outline: none;
   box-shadow: 0 0 0 2px #93c5fd;
 }
  .sign-head{
   margin: 0 auto;
   max-width: 400px;
  } 
  /* Target the number input */
 input[type="number"]::-webkit-inner-spin-button,
 input[type="number"]::-webkit-outer-spin-button {
   -webkit-appearance: none;
   margin: 0;
 }
  /* Hide the increment and decrement icons */
 input[type="number"]::-webkit-inner-spin-button,
 input[type="number"]::-webkit-outer-spin-button {
   display: none;
 }
   </style>